import "antd/lib/modal/style";
import _Modal from "antd/lib/modal";
import "antd/lib/checkbox/style";
import _Checkbox from "antd/lib/checkbox";
import "antd/lib/divider/style";
import _Divider from "antd/lib/divider";
import "antd/lib/alert/style";
import _Alert from "antd/lib/alert";
import "antd/lib/space/style";
import _Space from "antd/lib/space";
import "antd/lib/button/style";
import _Button from "antd/lib/button";
import _defineProperty from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.regexp.to-string.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import React, { useState, useEffect } from 'react';
import { cookiesAgreedCognitoKey } from 'const';
import { useSelector, useDispatch } from 'react-redux';
import { updateUserAttributes } from 'redux/actions/user';
var CookieBanner = function CookieBanner() {
  var dispatch = useDispatch();
  var user = useSelector(function (state) {
    return state.user.current;
  });
  var cookiesAgreed = user.attributes[cookiesAgreedCognitoKey];
  var _useState = useState(false),
    modalVisible = _useState[0],
    setModalVisible = _useState[1];
  var _useState2 = useState(cookiesAgreed === undefined),
    bannerVisible = _useState2[0],
    setBannerVisible = _useState2[1];
  var _useState3 = useState({
      performance: false
    }),
    consent = _useState3[0],
    setConsent = _useState3[1];
  useEffect(function () {
    if (cookiesAgreed !== undefined) {
      setBannerVisible(false);
    } else {
      setBannerVisible(true);
    }
  }, [cookiesAgreed]);
  var updateUserChoice = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(consentChoice) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return dispatch(updateUserAttributes(user, _defineProperty({}, cookiesAgreedCognitoKey, consentChoice.toString())));
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function updateUserChoice(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  var handleAcceptAll = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            setBannerVisible(false);
            setModalVisible(false);
            _context2.next = 4;
            return updateUserChoice(true);
          case 4:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function handleAcceptAll() {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleRejectAll = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            setBannerVisible(false);
            setModalVisible(false);
            _context3.next = 4;
            return updateUserChoice(false);
          case 4:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function handleRejectAll() {
      return _ref3.apply(this, arguments);
    };
  }();
  var handleSavePreferences = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            setModalVisible(false);
            setBannerVisible(false);
            _context4.next = 4;
            return updateUserChoice(consent.performance);
          case 4:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function handleSavePreferences() {
      return _ref4.apply(this, arguments);
    };
  }();
  var handleCustomize = function handleCustomize() {
    setModalVisible(true);
  };
  return __jsx("div", null, bannerVisible && __jsx("div", {
    style: {
      position: 'fixed',
      bottom: 0,
      width: '100%',
      zIndex: 1000
    }
  }, __jsx(_Alert, {
    message: "We use cookies to improve your experience on our site. You can customize your preferences.",
    description: __jsx("a", {
      href: "https://www.parsebiosciences.com/trailmaker-cookie-policy/",
      target: "_blank",
      rel: "noopener noreferrer"
    }, "Read our full cookie policy"),
    type: "info",
    showIcon: true,
    style: {
      fontSize: '16px',
      padding: '16px 24px'
    } // Adjusted padding for better spacing
    ,
    action: __jsx(_Space, null, __jsx(_Button, {
      size: "large",
      type: "primary",
      onClick: handleRejectAll
    }, "Reject"), __jsx(_Button, {
      size: "large",
      type: "primary",
      onClick: handleCustomize
    }, "Customize"), __jsx(_Button, {
      size: "large",
      type: "primary",
      onClick: handleAcceptAll
    }, "Accept All"))
  })), __jsx(_Modal, {
    title: "Cookie Settings",
    open: modalVisible,
    onCancel: function onCancel() {
      return setModalVisible(false);
    },
    footer: [__jsx(_Button, {
      key: "save",
      type: "primary",
      onClick: handleSavePreferences
    }, "Save Preferences"), __jsx(_Button, {
      key: "reject",
      type: "primary",
      onClick: handleRejectAll
    }, "Reject Other Cookies"), __jsx(_Button, {
      key: "accept",
      type: "primary",
      onClick: handleAcceptAll
    }, "Accept All")]
  }, __jsx(_Divider, {
    style: {
      marginTop: 0
    }
  }, "Essential Cookies"), __jsx(_Checkbox, {
    checked: true,
    disabled: true
  }, "Essential cookies are crucial to your experience of a website, enabling core features like user logins and account management."), __jsx(_Divider, null, "Other cookies and Session Replay Technology"), __jsx(_Checkbox, {
    checked: consent.performance,
    onChange: function onChange(e) {
      return setConsent(_objectSpread(_objectSpread({}, consent), {}, {
        performance: e.target.checked
      }));
    }
  }, "We track how you use the website during your visit. This includes taking a recording of your actions on the website (\u201CSession Replay Technology\u201D). You can ask us not to do it by unchecking this checkbox or clicking \u201Creject other cookies\u201D.")));
};
export default CookieBanner;